import { useI18n } from "../../../i18n/I18nContext";
import Footer from "../Footer/Footer";

const catalogUrls = {
  pt: "https://online.fliphtml5.com/racksforall/ojdz/",
  en: "https://online.fliphtml5.com/racksforall/jbjc/",
  es: "https://online.fliphtml5.com/racksforall/fqgp/",
  de: "https://online.fliphtml5.com/racksforall/catalogoGER/",
  it: "https://online.fliphtml5.com/racksforall/catalogoIT/",
  fr: "https://online.fliphtml5.com/racksforall/bkja/",
};

const catalogTitles = {
  pt: "Catálogo Completo de Produtos RacksForAll",
  en: "RacksForAll Complete Product Catalog",
  es: "Catálogo Completo de Productos RacksForAll",
  de: "Vollständiger RacksForAll Produktkatalog",
  it: "Catalogo Completo dei Prodotti RacksForAll",
  fr: "Catalogue Complet des Produits RacksForAll",
};

const downloadLabels = {
  pt: "Descarregar catálogo em PDF",
  en: "Download PDF Catalog",
  es: "Descargar catálogo en PDF",
  de: "PDF-Katalog herunterladen",
  it: "Scarica catalogo PDF",
  fr: "Télécharger le catalogue PDF",
};

export default function Catalogo() {
  const { language, t } = useI18n();
  const pdfUrl = `/catalogo-${language}.pdf`;
  const flipHtml5Url = catalogUrls[language] || catalogUrls.pt;
  const iframeTitle = catalogTitles[language] || catalogTitles.pt;
  const downloadLabel = downloadLabels[language] || downloadLabels.pt;

  return (
    <div>
      <main
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "100px 24px 80px",
        }}
      >
        {/* Cabeçalho e botão de download */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
            marginBottom: "24px",
          }}
        >
          <h1
            style={{
              fontSize: "28px",
              fontWeight: "600",
              margin: 0,
            }}
          >
            {t("Catálogo de Produtos")}
          </h1>

          <a
            href={pdfUrl}
            download={`catalogo-${language}.pdf`}
            style={{
              display: "inline-block",
              backgroundColor: "#246cd6",
              color: "#ffffff",
              padding: "12px 24px",
              borderRadius: "6px",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "15px",
            }}
          >
            {downloadLabel}
          </a>
        </div>

        {/* Catálogo FlipHTML5 */}
        <div
          style={{
            position: "relative",
            width: "100%",
            paddingTop: "max(60%, 324px)",
            height: 0,
          }}
        >
          <iframe
            style={{
              position: "absolute",
              border: "none",
              width: "100%",
              height: "100%",
              left: 0,
              top: 0,
            }}
            src={flipHtml5Url}
            title={iframeTitle}
            scrolling="no"
            allowFullScreen
          />
        </div>
      </main>

      <Footer />
    </div>
  );
}

